<template>
  <b-modal id="modal-avaliacao" data-backdrop="static" data-keyboard="false" centered
    :title="this.$t('Realizar avaliação')">
    <div style="text-align: center;">
      <div class="rating">
        <span v-for="rating in 10" :key="rating">
          <input type="radio" :id="'star' + rating" :value="rating" @click="selectRating(rating)">
          <label :for="'star' + rating" class="star" :class="{ 'filled': rating <= selectedRating }"></label>
        </span>
      </div>
      <p>{{ $t('Nota selecionada') }}: {{ selectedRating }}</p>
    </div>
    <div style="text-align: center;">
      <span for="obsItem">{{ $t('Observação') }} ({{ $t('Opcional') }}):</span>
      <input v-model="observacao" type="text" class="form-control" id="obsItem">
    </div>
    <template #modal-footer>
      <div class="w-100">
        <div class="row center" style="justify-content: center;">
          <b-button class="mr-2" variant="danger" size="lg" @click="pularAvaliacao">
            {{ $t('Pular') }}
          </b-button>
          <b-button size="lg" variant="success" @click="enviarAvaliacao">
            {{ $t('Enviar') }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>

export default {
  name: "ModalExterna",
  props: {
    pesquisa: {},
    item: {}
  },
  data() {
    return {
      selectServico: "",
      observacao: "",
      idConjunto: "",
      fornecedores: "",
      selectedRating: null
    };
  },
  created() {
  
  },

  computed: {

  },
  methods: {
    enviarAvaliacao() {
      if(!this.selectedRating){
        this.$swal.fire({
          title: this.$t('Oops!'),
          text: this.$t('Informe uma nota'),
          icon: 'warning'
        })
        
        return false
      }

      if(this.selectedRating <= 6 && !this.observacao){
        this.$swal.fire({
          title: this.$t('Oops!'),
          text: this.$t('Informe uma justificativa'),
          icon: 'warning'
        })
        
        return false
      }

      const avaliacao = {
        cd_clifor: this.pesquisa.tecnicoId,
        observacao: this.observacao,
        nota: this.selectedRating,
        nr_seq_pesquisa: this.pesquisa.nr_seq_pesquisa,
        loginExterno: this.pesquisa.loginExterno
      }

      this.$store.dispatch('colaborador/enviarAvaliacao', { data: avaliacao }).then(() => {
        this.$bvModal.hide('modal-avaliacao')
        const filial = this.$store.getters['filial/filial']
        this.executarRedirecionamento(filial)
      })

    },

    pularAvaliacao() {
      this.$bvModal.hide('modal-avaliacao')
      const filial = this.$store.getters['filial/filial']
      this.executarRedirecionamento(filial)
    },

    executarRedirecionamento(filial) {
      if (filial.perfilMecanico == 'E') {
        this.$router.push('/osEmpilhadeira').catch(err => { console.error(err) })
      } else if (filial.fornecExt === 'S') {
        this.$router.push('/osExterna').catch(err => { console.error(err) })
      } else {
        this.$router.push('/').catch(err => { console.error(err) })
      }
    },

    selectRating(rating) {
      if (this.selectedRating === rating) {
        this.selectedRating = rating - 1;
      } else {
        this.selectedRating = rating;
      }
    }
  },

}
</script>
<style>
#modalItems {
  pointer-events: none !important;
}

.close {
  display: none !important;
}

.star {
  font-size: 40px;
  color: #ccc;
  cursor: pointer;
}

.star:before {
  content: '★';
}

input[type="radio"] {
  display: none;
}

.filled:before {
  content: '★';
  color: #ffcc00;
}
</style>